import { RuleSet } from '@/typings/form';

export const rules: RuleSet = {
  username: [{ required: true, message: 'Please input username' }],
  password: [{ required: true, message: 'Please input password' }],
};
